// Noms des collections Firestore
export const COLLECTIONS = {
  USERS: 'users',
  WORK_REQUESTS: 'workRequests',
  SERVICES: 'services',
  SCHOOLS: 'schools',
  NOTIFICATIONS: 'notifications',
  COMMENTS: 'comments',
  SETTINGS: 'settings',
  LOGS: 'logs',
  INTERVENTIONS: 'interventions',
  WORK_REQUEST_COMMENTS: 'workRequestComments',
  CALENDAR_EVENTS: 'calendar_events',
  WORK_REQUEST_FEEDBACK: 'workRequestFeedback',
  SECTORS: 'sectors',
};

// Types de documents
export const DOCUMENT_TYPES = {
  // Types de demandes
  WORK_REQUEST_STATUS: {
    PENDING_VALIDATION: 'pending_validation',
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
  },
  
  // Priorités des demandes
  WORK_REQUEST_PRIORITY: {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent',
  },
  
  // Rôles utilisateurs
  USER_ROLES: {
    USER: 'user',
    SERVICE: 'service',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super_admin',
  },
  
  // Types de notifications
  NOTIFICATION_TYPES: {
    NEW_REQUEST: 'new_request',
    STATUS_UPDATE: 'status_update',
    COMMENT: 'comment',
    ASSIGNMENT: 'assignment',
    PRIORITY_UPDATE: 'priority_update',
  },
  
  // Statuts des notifications
  NOTIFICATION_STATUS: {
    UNREAD: 'unread',
    READ: 'read',
    ARCHIVED: 'archived',
  },
};

// Structure des documents
export const DOCUMENT_STRUCTURE = {
  WORK_REQUEST: {
    assignedServiceId: 'string',
    createdAt: 'timestamp',
    createdBy: 'string',
    description: 'string',
    location: {
      building: 'string',
      floor: 'string',
      room: 'string'
    },
    priority: 'string',
    problem: 'string',
    requestingServiceId: 'string',
    schoolId: 'string',
    status: 'string'
  },
  
  COMMENT: {
    workRequestId: 'string',
    userId: 'string',
    content: 'string',
    createdAt: 'timestamp',
    updatedAt: 'timestamp?',
    attachments: 'array?',
    isInternal: 'boolean?',
  },
  
  NOTIFICATION: {
    type: 'string',
    workRequestId: 'string',
    serviceId: 'string',
    message: 'string',
    status: 'string',
    createdAt: 'timestamp',
    readAt: 'timestamp?',
  },
  
  USER: {
    email: 'string',
    displayName: 'string',
    role: 'string',
    serviceId: 'string?',
    active: 'boolean',
    createdAt: 'timestamp',
    lastLoginAt: 'timestamp?',
  },
  
  SERVICE: {
    id: 'string',
    adminId: 'string',
    createdAt: 'timestamp',
    createdBy: 'string',
    email: 'string',
    isActive: 'boolean',
    name: 'string',
    phone: 'string',
    role: 'string',
    schoolId: 'string',
    type: 'string',
    updatedAt: 'timestamp'
  },
  
  SCHOOL: {
    name: 'string',
    address: 'string',
    city: 'string',
    phone: 'string',
    email: 'string',
    contactPerson: 'string',
    active: 'boolean'
  },
  
  SETTING: {
    key: 'string',
    value: 'any',
    description: 'string',
    updatedAt: 'timestamp',
    updatedBy: 'string',
  },
  
  LOG: {
    type: 'string',
    action: 'string',
    userId: 'string',
    details: 'map',
    timestamp: 'timestamp',
    ip: 'string?',
  },
};
